import { useQuery } from '@tanstack/react-query';
import { listSubscriptions } from '../services/subscriptions.api';
import type { SubscriptionListQuery } from '../types';

export function useSubscriptions(query?: SubscriptionListQuery) {
  return useQuery({
    queryKey: ['subscriptions', 'list', query],
    queryFn: () => listSubscriptions(query),
  });
}
